<template>
  <section class="register-container">
    <div class="page-content">
      <div class="panel">
        <div class="panel-body">
          <div class="brand">
            <img class="brand-img" src="../assets/img/logo-olli.png" width="100" style="border-radius: 50%">
            <h1 class="brand-text font-size-18">Welcome to Skill Builder</h1>
          </div>
          <el-form autoComplete="on" status-icon label-position="left" label-width="0" :model="registerForm" :rules="rules" ref="registerForm" class="login-form register-form" >
            <el-form-item prop="full_name">
              <el-input
              v-model="registerForm.full_name"
              prefix-icon="el-icon-fa-user"
              name="full_name"
              type="text"
              placeholder="Fullname" />
            </el-form-item>
            <el-form-item prop="email">
              <el-input
              tabindex="2"
              prefix-icon="el-icon-fa-envelope"
              name="email"
              type="text"
              autoComplete="on"
              placeholder="Email"
              v-model="registerForm.email"
               />
            </el-form-item>
            <el-form-item prop="password">
              <el-input
              tabindex="3"
              prefix-icon="el-icon-fa-key"
              name="password"
              type="password"
              autoComplete="on"
              placeholder="Password"
              v-model="registerForm.password"/>
            </el-form-item>
            <el-form-item prop="checkPass">
              <el-input
              tabindex="4"
              prefix-icon="el-icon-fa-key"
              name="checkPass"
              type="password"
              autoComplete="on"
              placeholder="Enter the password again"
              v-model="registerForm.checkPass"/>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" style="width: 100%;" @click="submitForm">Register</el-button>
            </el-form-item>
             <el-form-item>
              <a class="link-register" href="/?#/login">Already have an account? Log in</a>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

export default {
  name: 'Register',

  data () {
    return {
      loading: false,
      submitted: false,
      registerForm: {
        full_name: '',
        email: '',
        password: '',
        checkPass: '',
      },
      refs: {
        registerForm: HTMLFormElement,
      },
      rules: {
        full_name: [
          {
            required: true,
            message: 'Full name is required',
            trigger: 'blur',
          },
        ],
        email: [
          {
            type: 'email',
            required: true,
            message: 'Email is invalid',
            trigger: 'blur',
          },
        ],
        password: [
          {
            validator: this.validatePass,
            trigger: 'blur',
          },
        ],
        checkPass: [
          {
            validator: this.validatePass2,
            trigger: 'blur',
          },
        ],
      },

    }
  },
  methods: {
    validatePass (rule, value, callback) {
      if (value === '') {
        callback(new Error('Please input the password'))
      } else {
        if (this.registerForm.checkPass !== '') {
          this.$refs.registerForm.validateField('checkPass')
        }
        callback()
      }
    },
    validatePass2 (rule, value, callback) {
      if (value === '') {
        callback(new Error('Please input the password again'))
      } else if (value !== this.registerForm.password) {
        callback(new Error('Confirm password is not match'))
      } else {
        callback()
      }
    },
    submitForm () {
      this.$refs.registerForm.validate(async valid => {
        console.log(valid)
        if (valid) {
          console.log('submit now!')
          await alert('submit')
        } else {
          console.log('error submit')
          return false
        }
      })
    },
    onerror (error, prefix) {
      console.error(error)
      prefix = prefix || 'Error'
      let message = error.responseJSON
        ? error.responseJSON.errors.join(', ') : error
      this.$message({
        message: prefix + ': ' + message,
        type: 'error',
      })
    },
  },

}
</script>

<style lang="scss">
html,
body {
  .register-container {
    width: 100%;
    height: 100vh;
    font-weight: 100;
    background-image: url('../assets/img/bg_login.jpg');
    background-repeat: repeat-x;
    background-position: center top;
    -webkit-background-size: cover;
    background-size: cover;

    .page-content {
      text-align: center;
      display: flex;
      align-items: center;
      width: 100%;
      height: 100vh;
      justify-content: center;

      .panel {
        width: 400px;
        margin-bottom: 45px;
        background: #fff;
        border-radius: 4px;
        display: inline-block;
        vertical-align: middle;

        .panel-body {
          padding: 50px 40px 40px;
          margin-left: 0 !important;
          min-height: 100%;
          max-height: 100%;

          .brand-text {
            font-size: 22px;
            font-weight: bold;
            text-shadow: rgba(0, 0, 0, 0.15) 0 0 1px;
          }
          .register-form {
            margin: 30px 0 30px;

            .el-form-item {
              margin-bottom: 22px;
            }
          }
        }
      }
    }
  }
}
</style>
